import { DownloadOutlined, EditOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Image, Input, Tag, Tooltip } from "antd";
import React, { useState, useRef } from "react";
import Container from "../General/Container/Container";
import CustomTable from "../../customcomponents/customtable/CustomTable";
import { HiOutlineLightBulb } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { setPersonasParams, setResultMode, setVisibleRecomInsights } from "../../store/components/Minified.slice";
import { downloadRecommendationItem } from "../../utils/oneintelligence/OneIntelligenceHelper";
import { useEffect } from "react";
import { setVisibleAddAudienceModal, setVisiblePersonasModal } from "../../store/components/Reports.slice";
import MinifiedDetails from "./MinifiedDetails";
import { getClassType, getImage, getInterestLevel, getTrackKeyCreatePackage, hightLightHeader, scrollTo } from "../../utils/minified/MinifiedHelper";
import { formatNumber, isHasPersonasPermission } from "../../utils/MainHelper";

const MinifiedRecommendedItem = ({
    itemId = "he",
    data = {
        name: "Audience 1",
        targetSize: 14003,
        targetAudience: "Nike",
        list: []
    },
    setHeActiveKeys = () => { },
    setAiActiveKeys = () => { },
    onChangeName = () => { }
}) => {
    const dispatch = useDispatch()
    const renameRef = useRef()
    const [renameAudience, setRenameAudience] = useState(false);
    const [audienceName, setAudienceName] = useState(data.name)

    const expandItems = (value, isAll) => {
        const expandHe = () => {
            if (isAll) {
                return setHeActiveKeys(data.list.map((d) => d.discoveredCategory))
            }
            return setHeActiveKeys((state) => {
                if (state.includes(value)) return state
                return [...state, value]
            })
        }
        const expandAi = () => {
            if (isAll) {
                return setAiActiveKeys(data.list.map((d) => d.discoveredCategory))
            }
            return setAiActiveKeys((state) => {
                if (state.includes(value)) return state
                return [...state, value]
            })
        }
        if (itemId === "he") {
            return expandHe()
        }
        if (itemId === "ai") {
            return expandAi()
        }
        return Promise.all([expandHe(), expandAi()])
    }
    const onRenameAudienceName = (e) => {
        setRenameAudience(false)
        onChangeName({
            key: itemId,
            name: e.target.value
        })
    }
    const onClickInsights = () => {
        dispatch(setVisibleRecomInsights({
            data: {
                ...data,
                itemId,
                interestLevel: getInterestLevel(itemId),
                classType: getClassType(itemId),
            },
            visible: true
        }));
    }
    const newList = [...data.list || []].slice(0, 3);

    useEffect(() => {
        if (renameAudience && renameRef.current) {
            renameRef.current.focus()
        }
    }, [renameAudience])

    return <Container className="minified-recommended-item dcol">
        <Image preview={false} src={getImage(itemId)} />
        <Container className="minified-recommended-item-header dcol">
            {renameAudience
                ? <Input
                    ref={renameRef}
                    className="minified-recommended-item-rename"
                    bordered={false} value={audienceName}
                    onChange={(e) => {
                        setAudienceName(e.target.value)
                    }}
                    onPressEnter={onRenameAudienceName}
                    onBlur={onRenameAudienceName}
                />
                : <span>{data.name}<EditOutlined style={{ cursor: "pointer" }} onClick={() => {
                    setRenameAudience(true)
                }} /></span>
            }
            <span>{formatNumber(data.targetSize)}</span>
            <span>target size</span>
        </Container>
        <Container className="minified-recommended-item-header-download">
            <Button icon={<DownloadOutlined />} type="link" onClick={() => {
                downloadRecommendationItem({
                    ...data,
                    interestLevel: getInterestLevel(itemId)
                })
            }} />
        </Container>
        <Container className="minified-recommended-item-body dcol fullh">
            <MinifiedDetails className="dcol gap-5p" itemId={itemId} data={data} onClickAgeGender={onClickInsights} />
            <span className="border-item" />
            <Container className="dcol f1">
                <CustomTable
                    noNum
                    noCheckbox
                    pagination={false}
                    tableProps={{
                        expandable: false,
                        bordered: true,
                        size: "small"
                    }}
                    columns={[
                        {
                            title: "Categories",
                            key: "discoveredCategory",
                            render: (value) => {
                                return <Tooltip placement="topLeft" title={value}>
                                    <Tag className="minified-recommended-item-table-name"
                                        onClick={() => {
                                            // expandItems(value)
                                            scrollTo(itemId, value)
                                            hightLightHeader(itemId)
                                        }}
                                    >{value}</Tag>
                                </Tooltip>
                            }

                        },
                        {
                            title: "Behaviors",
                            key: "count",
                            align: "right",
                            render: (value, row) => row.children.length,
                            width: 85
                        },
                        {
                            title: "Size",
                            key: "size",
                            align: "center",
                            render: (value) => formatNumber(value)
                        },
                    ]}
                    dataSource={newList}
                />
            </Container>
            <Container className="dcol gap-1">
                <Button type="link" className="minified-recommended-item-seemore" onClick={async () => {
                    const lastItems = data.list[0]
                    // await expandItems(lastItems.discoveredCategory, true)
                    scrollTo(itemId, lastItems.discoveredCategory, true)
                    hightLightHeader(itemId)
                }}>
                    See more ({data.list.length})
                </Button>
            </Container>
            <span className="border-item" />
            <Container className="minified-recommended-item-footer-action drow justify-between">
                <Container className="drow gap-1">
                    <Button icon={<HiOutlineLightBulb />} type="link" onClick={onClickInsights}>Insights</Button>
                    {/* <Button icon={<UserOutlined />} type="link" onClick={() => {
                        if (isHasPersonasPermission()) {
                            dispatch(setResultMode("personas"));
                            dispatch(setPersonasParams({
                                ...data,
                                itemId,
                                interestLevel: getInterestLevel(itemId),
                                classType: getClassType(itemId),
                            }));
                        } else {
                            dispatch(setVisiblePersonasModal({
                                data: null,
                                visible: true
                            }))
                        }
                    }}>Personas</Button> */}
                </Container>
                <Button type="primary" onClick={() => {
                    dispatch(setVisibleAddAudienceModal({
                        visible: true,
                        trackKey: getTrackKeyCreatePackage(itemId),
                        toAddNewAudience: data.list.reduce((acc, items) => {
                            const { tempChildren, children } = items
                            acc = acc.concat(tempChildren || children || [])
                            return acc
                        }, []),
                        toAddNewAudienceName: data.name,
                    }));
                }}>Create Package</Button>
            </Container>
        </Container>
    </Container>
}

export default MinifiedRecommendedItem